/* ============================================================
   DOGS SUPREME · <ds-nav-check>
   Futterwechsel-Check: gefuehrter Fragebogen mit Sicherheitslogik
   und persoenlichem Orientierungsplan. Herz der Navigator-Plattform
   (docs/navigator-plattform.md, P1).

   Grundsaetze:
   · Client-only: Antworten NUR in localStorage (ds_nav_check_v1),
     keine Server-Speicherung von Gesundheitsdaten, kein Konto.
   · Sicherheits-Weichen VOR jedem Plan:
       R  rote Flagge            -> Tierarzt-Ausgang, KEIN Plan, KEINE Bridge
       K  Welpe/traechtig/Diagnose -> konservativ, keine Automatik-Mengen
       B  wiederkehrende Signale -> strukturiert beobachten (Tagebuch),
                                    keine Kauf-Bridge (Serioesitaet)
       A  gesunder Adult         -> voller Orientierungsplan + EINE Bridge
   · Sprache: begleiten/strukturieren, nie diagnostizieren/heilen (HCVO).
   · Mengen-Staffel identisch ds-futter-rechner.js (Futterfibel 2/1,8/4 %).
     # vereinfachung: 5-Zeilen-Formel bewusst dupliziert statt globalem
     Core-Bundle; Decke: bei 3. Kopie in gemeinsames Asset ziehen.

   UI-Schicht: Design kommt aus assets/ds-nav-foundation.css (.dsn-*),
   Spec docs/standards/navigator-design-spec.md. injectStyles hier traegt
   nur noch Check-Individuelles (Print). Fehlt die Foundation im Dokument,
   laedt ensureFoundation() sie ueber den eigenen Script-Pfad nach.

   Kompatibilitaet wie ds-audio.js: ES2015-class, keine #-Felder,
   kein Optional-Chaining, var + function, reduced-motion, aria-live.
   ============================================================ */
(function () {
  'use strict';

  var FACTORS = { normal: 0.02, mollig: 0.018, duenn: 0.04 };
  function round5(n) { return Math.round(n / 5) * 5; }
  function computeRation(kg, zustand) {
    var f = FACTORS[zustand];
    if (!f || typeof kg !== 'number' || !isFinite(kg) || kg <= 0) return null;
    var perDay = round5(kg * 1000 * f);
    return { gramsPerDay: perDay, gramsPerMeal: round5(perDay / 2), factor: f };
  }

  /* ---------- Fall-Klassifikation (pur, Node-testbar) ----------
     answers = {
       alter: 'welpe'|'erwachsen'|'senior',
       figur: 'duenn'|'normal'|'mollig',
       traechtig: bool,
       diagnose: 'keine'|'futter'|'andere',
       flags: [ 'blut'|'erbrechen'|'schwaeche'|'gewicht'|'atem' ],
       beob:  [ 'weich'|'durchfall_oft'|'blaehungen'|'juckreiz'|'ohren'|'haut'|'waehlerisch' ]
     }
     Rueckgabe { fall:'R'|'K'|'B'|'A', slow:bool, reasons:[...] }          */
  function classify(a) {
    var reasons = [];
    var flags = a.flags || [];
    var beob = a.beob || [];

    if (flags.length > 0) {
      return { fall: 'R', slow: false, reasons: ['rote_flagge'].concat(flags) };
    }
    if (a.alter === 'welpe') reasons.push('welpe');
    if (a.traechtig) reasons.push('traechtig');
    if (a.diagnose === 'futter' || a.diagnose === 'andere') reasons.push('diagnose_' + a.diagnose);
    if (reasons.length > 0) {
      return { fall: 'K', slow: false, reasons: reasons };
    }

    var b2 = [];
    if (beob.indexOf('durchfall_oft') !== -1) b2.push('durchfall_oft');
    if (beob.indexOf('juckreiz') !== -1) b2.push('juckreiz');
    if (beob.indexOf('ohren') !== -1) b2.push('ohren');
    if (beob.indexOf('haut') !== -1) b2.push('haut');
    if (b2.length > 0) {
      return { fall: 'B', slow: false, reasons: b2 };
    }

    var mild = beob.filter(function (x) {
      return x === 'weich' || x === 'blaehungen' || x === 'waehlerisch';
    });
    return { fall: 'A', slow: mild.length > 0, reasons: mild };
  }

  /* 7-Tage-Uebergangsschema; slow=true streckt auf 14 Tage. */
  function transitionPlan(slow) {
    if (slow) {
      return [
        { tage: 'Tag 1 bis 3', neu: 25 }, { tage: 'Tag 4 bis 7', neu: 50 },
        { tage: 'Tag 8 bis 11', neu: 75 }, { tage: 'ab Tag 12', neu: 100 }
      ];
    }
    return [
      { tage: 'Tag 1 und 2', neu: 25 }, { tage: 'Tag 3 und 4', neu: 50 },
      { tage: 'Tag 5 und 6', neu: 75 }, { tage: 'ab Tag 7', neu: 100 }
    ];
  }

  function boxDays(boxGrams, gramsPerDay) {
    if (!(boxGrams > 0) || !(gramsPerDay > 0)) return null;
    var d = Math.round(boxGrams / gramsPerDay);
    if (d < 2 || d > 60) return null;
    return d;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      classify: classify, computeRation: computeRation,
      transitionPlan: transitionPlan, boxDays: boxDays, FACTORS: FACTORS
    };
    return;
  }

  if (!('customElements' in window) || customElements.get('ds-nav-check')) return;

  var LS_KEY = 'ds_nav_check_v1';

  /* Foundation-Stylesheet nachladen, falls die Section/Vorlage es nicht traegt
     (Pfad aus dem eigenen script-src abgeleitet, gleiches Shopify-CDN-Verzeichnis). */
  function ensureFoundation() {
    if (document.getElementById('dsn-foundation')) return;
    var probe = document.querySelector('link[href*="ds-nav-foundation"]');
    if (probe) { probe.id = probe.id || 'dsn-foundation'; return; }
    var self = document.querySelector('script[src*="ds-nav-check"]');
    if (!self) return;
    var link = document.createElement('link');
    link.id = 'dsn-foundation';
    link.rel = 'stylesheet';
    link.href = self.src.split('?')[0].replace(/ds-nav-check\.js$/, 'ds-nav-foundation.css');
    document.head.appendChild(link);
  }

  function injectStyles() {
    if (document.getElementById('ds-nav-check-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-nav-check-styles';
    style.textContent = [
      "ds-nav-check .dsnc-actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:14px}",
      "@media (max-width:480px){ds-nav-check .dsnc-actions{flex-direction:column;align-items:stretch}}",
      "@media print{body *{visibility:hidden}ds-nav-check,ds-nav-check *{visibility:visible}",
      "ds-nav-check{position:absolute;left:0;top:0;width:100%}",
      "ds-nav-check .dsnc-actions,ds-nav-check .dsn-dock,ds-nav-check .dsn-progress,",
      "ds-nav-check .dsnc-bridge-wrap{display:none!important}",
      "ds-nav-check .dsn-card{border:none;box-shadow:none;padding:0}}"
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  var TICK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  var CHEVRON_LEFT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="13 6 19 12 13 18"></polyline></svg>';

  var BEOB_OPTS = [
    { v: 'weich', label: 'Gelegentlich weicher Kot' },
    { v: 'durchfall_oft', label: 'Häufiger Durchfall oder Erbrechen' },
    { v: 'blaehungen', label: 'Blähungen' },
    { v: 'juckreiz', label: 'Juckreiz oder Pfotenlecken' },
    { v: 'ohren', label: 'Wiederkehrende Ohrenprobleme' },
    { v: 'haut', label: 'Auffällige Haut oder Haarausfall' },
    { v: 'waehlerisch', label: 'Frisst schlecht oder wählerisch' }
  ];
  var FLAG_OPTS = [
    { v: 'blut', label: 'Blut im Kot' },
    { v: 'erbrechen', label: 'Wiederholtes Erbrechen (mehrfach täglich oder über Tage)' },
    { v: 'schwaeche', label: 'Deutliche Schwäche oder Apathie' },
    { v: 'gewicht', label: 'Schneller Gewichtsverlust' },
    { v: 'atem', label: 'Atemprobleme' }
  ];

  class DsNavCheck extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      ensureFoundation();
      injectStyles();

      this.boxUrl = this.getAttribute('box-url') || '/products/barf-kennenlern-box';
      this.boxGrams = parseInt(this.getAttribute('box-grams') || '2000', 10);
      this.tagebuchUrl = this.getAttribute('tagebuch-url') || '';

      this.state = this.load() || {
        step: 0, kg: '', alter: 'erwachsen', figur: 'normal',
        traechtig: false, diagnose: 'keine', beob: [], flags: []
      };
      this.renderShell();
      this.renderStep(true);
    }

    load() {
      try {
        var raw = localStorage.getItem(LS_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }
    save() {
      try {
        this.state.savedAt = new Date().toISOString();
        localStorage.setItem(LS_KEY, JSON.stringify(this.state));
      } catch (e) {}
    }

    renderShell() {
      this.card = el('div', 'dsn-card');
      this.progress = el('div', 'dsn-progress');
      this.progressDots = el('div', 'dsn-progress-dots');
      for (var i = 0; i < 5; i++) this.progressDots.appendChild(el('span', 'dsn-dot'));
      this.progress.appendChild(this.progressDots);
      this.progressLabel = el('span', 'dsn-progress-label');
      this.progress.appendChild(this.progressLabel);
      this.card.appendChild(this.progress);
      this.bodyEl = el('div', '');
      this.bodyEl.setAttribute('aria-live', 'polite');
      this.card.appendChild(this.bodyEl);
      this.appendChild(this.card);
    }

    setProgress(n) {
      var dots = this.progressDots.children;
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('dsn-done', i <= n);
      this.progressLabel.textContent = 'Schritt ' + (n + 1) + ' von 5';
      this.progress.style.display = n >= 0 ? 'flex' : 'none';
    }

    clearBody() { while (this.bodyEl.firstChild) this.bodyEl.removeChild(this.bodyEl.firstChild); }

    /* Schrittwechsel: Inhalt faded ein (reduced-motion: nur Opacity, CSS-seitig),
       Card-Oberkante bleibt im Blick. */
    swapBody(build, keepScroll) {
      this.clearBody();
      var wrap = el('div', 'dsn-step-in');
      build(wrap);
      this.bodyEl.appendChild(wrap);
      if (!keepScroll) {
        var top = this.card.getBoundingClientRect().top;
        if (top < 0 || top > 160) {
          this.card.scrollIntoView({ block: 'start', behavior: 'auto' });
          window.scrollBy(0, -84);
        }
      }
    }

    segRow(options, current, onChange) {
      var wrap = el('div', 'dsn-seg-track');
      options.forEach(function (opt) {
        var btn = el('button', 'dsn-seg', opt.label);
        btn.type = 'button';
        btn.setAttribute('aria-pressed', opt.v === current ? 'true' : 'false');
        btn.addEventListener('click', function () {
          var all = wrap.querySelectorAll('.dsn-seg');
          for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-pressed', 'true');
          onChange(opt.v);
        });
        wrap.appendChild(btn);
      });
      return wrap;
    }

    /* Auswahl-Liste im inset-grouped-Muster: Zeilen als Buttons mit
       aria-pressed, Tick-Kreis rechts. */
    checkList(options, list) {
      var self = this;
      var box = el('div', 'dsn-list');
      options.forEach(function (opt) {
        var row = el('button', 'dsn-row');
        row.type = 'button';
        row.setAttribute('aria-pressed', list.indexOf(opt.v) !== -1 ? 'true' : 'false');
        row.appendChild(el('span', '', opt.label));
        var tick = el('span', 'dsn-tick');
        tick.innerHTML = TICK_SVG;
        tick.setAttribute('aria-hidden', 'true');
        row.appendChild(tick);
        row.addEventListener('click', function () {
          var idx = list.indexOf(opt.v);
          if (idx === -1) { list.push(opt.v); row.setAttribute('aria-pressed', 'true'); }
          else { list.splice(idx, 1); row.setAttribute('aria-pressed', 'false'); }
          self.save();
        });
        box.appendChild(row);
      });
      return box;
    }

    /* Schwebendes Aktions-Dock: runder Zurueck-Chevron + Primaer-Kapsel. */
    dock(backFn, nextFn, nextLabel) {
      var wrap = el('div', 'dsn-dock');
      if (backFn) {
        var back = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--icon');
        back.type = 'button';
        back.innerHTML = CHEVRON_LEFT_SVG;
        back.setAttribute('aria-label', 'Zurück');
        back.addEventListener('click', backFn);
        wrap.appendChild(back);
      }
      var next = el('button', 'dsn-btn', nextLabel || 'Weiter');
      next.type = 'button';
      next.addEventListener('click', nextFn);
      wrap.appendChild(next);
      this.nextBtn = next;
      return wrap;
    }

    go(step) { this.state.step = step; this.save(); this.renderStep(); }

    renderStep(keepScroll) {
      var self = this;
      var s = this.state;

      if (s.step === 0) {
        this.setProgress(0);
        this.swapBody(function (root) {
          root.appendChild(el('p', 'dsn-q', 'Dein Hund'));
          root.appendChild(el('p', 'dsn-sub', 'Drei Angaben, mehr brauchen wir nicht. Nichts davon verlässt deinen Browser.'));

          var g1 = el('div', 'dsnc-group');
          g1.style.marginBottom = '16px';
          var lbl = el('label', 'dsn-label', 'Gewicht in kg');
          lbl.setAttribute('for', 'DsncKg');
          g1.appendChild(lbl);
          var field = el('div', 'dsn-field dsn-field--suffix');
          var input = el('input', 'dsn-input');
          input.id = 'DsncKg'; input.type = 'number'; input.step = '0.1';
          input.min = '0.5'; input.max = '100'; input.placeholder = 'z. B. 20';
          input.setAttribute('inputmode', 'decimal');
          input.value = s.kg;
          field.appendChild(input);
          var suffix = el('span', 'dsn-suffix', 'kg');
          suffix.setAttribute('aria-hidden', 'true');
          field.appendChild(suffix);
          g1.appendChild(field);
          var errLine = el('p', 'dsn-error-line', 'Bitte ein Gewicht zwischen 0,5 und 100 kg eintragen.');
          errLine.style.display = 'none';
          g1.appendChild(errLine);
          root.appendChild(g1);

          function validKg() {
            var kg = parseFloat(String(input.value).replace(',', '.'));
            return isFinite(kg) && kg >= 0.5 && kg <= 100;
          }
          function syncNext() {
            if (self.nextBtn) self.nextBtn.setAttribute('aria-disabled', validKg() ? 'false' : 'true');
          }
          input.addEventListener('input', function () {
            input.classList.remove('dsn-invalid');
            errLine.style.display = 'none';
            s.kg = input.value; self.save(); syncNext();
          });

          var g2 = el('div', 'dsnc-group');
          g2.style.marginBottom = '16px';
          g2.appendChild(el('span', 'dsn-label', 'Alter'));
          g2.appendChild(self.segRow(
            [{ v: 'welpe', label: 'Welpe' }, { v: 'erwachsen', label: 'Erwachsen' }, { v: 'senior', label: 'Senior' }],
            s.alter, function (v) { s.alter = v; self.save(); }));
          root.appendChild(g2);

          var g3 = el('div', 'dsnc-group');
          g3.appendChild(el('span', 'dsn-label', 'Figur'));
          g3.appendChild(self.segRow(
            [{ v: 'duenn', label: 'Zu dünn' }, { v: 'normal', label: 'Normal' }, { v: 'mollig', label: 'Etwas mollig' }],
            s.figur, function (v) { s.figur = v; self.save(); }));
          root.appendChild(g3);

          root.appendChild(self.dock(null, function () {
            s.kg = input.value; /* direkt aus dem DOM: Autofill/programmatische Fills feuern kein input-Event */
            var kg = parseFloat(String(s.kg).replace(',', '.'));
            if (!isFinite(kg) || kg < 0.5 || kg > 100) {
              input.classList.add('dsn-invalid');
              errLine.style.display = 'block';
              input.focus();
              return;
            }
            self.save(); self.go(1);
          }));
          syncNext();
        }, keepScroll);
        return;
      }

      if (s.step === 1) {
        this.setProgress(1);
        this.swapBody(function (root) {
          root.appendChild(el('p', 'dsn-q', 'Was beobachtest du gerade?'));
          root.appendChild(el('p', 'dsn-sub', 'Wähle alles, was in den letzten Wochen aufgefallen ist. Nichts dabei? Einfach weiter.'));
          root.appendChild(self.checkList(BEOB_OPTS, s.beob));
          root.appendChild(self.dock(function () { self.go(0); }, function () { self.go(2); }));
        }, keepScroll);
        return;
      }

      if (s.step === 2) {
        this.setProgress(2);
        this.swapBody(function (root) {
          root.appendChild(el('p', 'dsn-q', 'Gibt es Warnzeichen?'));
          root.appendChild(el('p', 'dsn-sub', 'Diese Punkte gehören nicht in einen Futterwechsel, sondern in die Tierarztpraxis. Sei hier ehrlich.'));
          root.appendChild(self.checkList(FLAG_OPTS, s.flags));
          root.appendChild(self.dock(function () { self.go(1); }, function () { self.go(3); }));
        }, keepScroll);
        return;
      }

      if (s.step === 3) {
        this.setProgress(3);
        this.swapBody(function (root) {
          root.appendChild(el('p', 'dsn-q', 'Was ist bekannt?'));
          root.appendChild(el('p', 'dsn-sub', 'Zwei Einordnungen, dann sind wir durch.'));
          var g1 = el('div', 'dsnc-group');
          g1.style.marginBottom = '16px';
          g1.appendChild(el('span', 'dsn-label', 'Tierärztliche Diagnose'));
          g1.appendChild(self.segRow(
            [{ v: 'keine', label: 'Keine' }, { v: 'futter', label: 'Futterbezogen' }, { v: 'andere', label: 'Andere' }],
            s.diagnose, function (v) { s.diagnose = v; self.save(); }));
          root.appendChild(g1);
          var g2 = el('div', 'dsnc-group');
          g2.appendChild(el('span', 'dsn-label', 'Trächtig oder säugend'));
          g2.appendChild(self.segRow(
            [{ v: 'nein', label: 'Nein' }, { v: 'ja', label: 'Ja' }],
            s.traechtig ? 'ja' : 'nein', function (v) { s.traechtig = (v === 'ja'); self.save(); }));
          root.appendChild(g2);
          root.appendChild(self.dock(function () { self.go(2); }, function () { self.go(4); }));
        }, keepScroll);
        return;
      }

      if (s.step === 4) {
        this.setProgress(4);
        this.swapBody(function (root) {
          root.appendChild(el('p', 'dsn-q', 'Alles beisammen.'));
          root.appendChild(el('p', 'dsn-sub', 'Wir werten deine Angaben aus und bauen deinen Orientierungsplan.'));
          root.appendChild(self.dock(function () { self.go(3); }, function () { self.go(5); }, 'Plan anzeigen'));
        }, keepScroll);
        return;
      }

      this.renderResult();
    }

    resetBtn() {
      var self = this;
      var b = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm', 'Check neu starten');
      b.type = 'button';
      b.addEventListener('click', function () {
        try { localStorage.removeItem(LS_KEY); } catch (e) {}
        self.state = { step: 0, kg: self.state.kg, alter: 'erwachsen', figur: 'normal', traechtig: false, diagnose: 'keine', beob: [], flags: [] };
        self.save(); self.renderStep();
      });
      return b;
    }

    printBtn(label) {
      var b = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm', label || 'Plan drucken');
      b.type = 'button';
      b.addEventListener('click', function () { window.print(); });
      return b;
    }

    actionRow(printLabel) {
      var row = el('div', 'dsnc-actions');
      row.appendChild(this.printBtn(printLabel));
      row.appendChild(this.resetBtn());
      return row;
    }

    renderResult() {
      var self = this;
      var s = this.state;
      this.setProgress(4);

      var kg = parseFloat(String(s.kg).replace(',', '.'));
      var res = classify({
        alter: s.alter, figur: s.figur, traechtig: s.traechtig,
        diagnose: s.diagnose, flags: s.flags, beob: s.beob
      });

      this.swapBody(function (root) {
        var box = el('div', 'dsn-result');

        if (res.fall === 'R') {
          box.appendChild(el('span', 'dsn-badge dsn-badge--error', 'Bitte zuerst in die Praxis'));
          box.appendChild(el('p', 'dsn-q', 'Das gehört jetzt in tierärztliche Hände.'));
          box.appendChild(el('p', 'dsn-text',
            'Mindestens eines deiner Warnzeichen sollte zeitnah abgeklärt werden, bevor du am Futter etwas änderst. ' +
            'Ein Futterwechsel wäre jetzt der falsche zweite Schritt.'));
          var sec = el('div', 'dsn-subcard');
          sec.appendChild(el('p', 'dsn-subcard-title', 'Deine Notiz für den Termin'));
          var labels = { blut: 'Blut im Kot', erbrechen: 'Wiederholtes Erbrechen', schwaeche: 'Deutliche Schwäche', gewicht: 'Schneller Gewichtsverlust', atem: 'Atemprobleme' };
          s.flags.forEach(function (f) {
            var row = el('div', 'dsn-kv');
            row.appendChild(el('span', '', labels[f] || f));
            row.appendChild(el('b', '', 'beobachtet'));
            sec.appendChild(row);
          });
          var row2 = el('div', 'dsn-kv');
          row2.appendChild(el('span', '', 'Gewicht'));
          row2.appendChild(el('b', '', String(s.kg).replace('.', ',') + '\u00A0kg'));
          sec.appendChild(row2);
          box.appendChild(sec);
          box.appendChild(el('p', 'dsn-note',
            'Drucke diese Notiz für den Termin aus. Danach helfen wir dir gern strukturiert weiter.'));
          box.appendChild(self.actionRow('Notiz drucken'));
          root.appendChild(box);
          return;
        }

        if (res.fall === 'K') {
          box.appendChild(el('span', 'dsn-badge', 'Besondere Situation'));
          box.appendChild(el('p', 'dsn-q', 'Hier passt keine Formel von der Stange.'));
          var why = [];
          if (res.reasons.indexOf('welpe') !== -1) why.push('Welpen und Junghunde wachsen, ihre Ration ändert sich laufend');
          if (res.reasons.indexOf('traechtig') !== -1) why.push('in Trächtigkeit und Säugezeit steigt der Bedarf deutlich und individuell');
          if (res.reasons.indexOf('diagnose_futter') !== -1 || res.reasons.indexOf('diagnose_andere') !== -1) why.push('mit einer bestehenden Diagnose gehört der Futterplan in tierärztliche Begleitung');
          box.appendChild(el('p', 'dsn-text',
            'Automatische Mengen zeigen wir dir hier bewusst nicht: ' + why.join('; ') + '. ' +
            'Lass dir den Plan von deiner Tierarztpraxis oder einer qualifizierten Ernährungsberatung erstellen. ' +
            'Was du heute schon tun kannst: Beobachtungen sauber dokumentieren, das hilft in jedem Gespräch.'));
          box.appendChild(self.actionRow('Hinweis drucken'));
          root.appendChild(box);
          return;
        }

        if (res.fall === 'B') {
          box.appendChild(el('span', 'dsn-badge', 'Strukturiert beobachten'));
          box.appendChild(el('p', 'dsn-q', 'Erst verstehen, dann wechseln.'));
          box.appendChild(el('p', 'dsn-text',
            'Deine Beobachtungen kommen wiederholt vor. Ein schneller Markenwechsel ist keine Diagnose: ' +
            'Wenn ein futterbezogener Auslöser abgeklärt werden soll, zählt ein sauberes Protokoll mehr als jedes neue Etikett. ' +
            'Sprich die Beobachtungen mit deiner Tierarztpraxis durch; eine echte Ausschlussdiät läuft tierärztlich geführt, ' +
            'häufig über 8 bis 12 Wochen, und wird durch Snacks und Kauartikel schnell verfälscht.'));
          var sec = el('div', 'dsn-subcard');
          sec.appendChild(el('p', 'dsn-subcard-title', 'Dein nächster Schritt'));
          sec.appendChild(el('p', 'dsn-text',
            'Führe zwei Wochen ein kurzes Futter-Tagebuch (Futter, Snacks, Kot, Juckreiz, Energie, je 30 Sekunden am Tag) ' +
            'und nimm es mit in die Praxis. So wird aus einem Bauchgefühl eine Grundlage.'));
          box.appendChild(sec);
          box.appendChild(el('p', 'dsn-note',
            'Bewusst kein Produkt an dieser Stelle: erst Klarheit, dann Empfehlung.'));
          box.appendChild(self.actionRow('Empfehlung drucken'));
          root.appendChild(box);
          return;
        }

        /* Fall A */
        var zustand = s.figur === 'duenn' ? 'duenn' : (s.figur === 'mollig' ? 'mollig' : 'normal');
        var senior = s.alter === 'senior';
        var ration = senior ? null : computeRation(kg, zustand);

        box.appendChild(el('span', 'dsn-badge', 'Dein Orientierungsplan'));
        box.appendChild(el('p', 'dsn-q', res.slow ? 'Umstellung: ja, aber im Schongang.' : 'Freie Bahn für den Wechsel.'));
        if (res.slow) {
          box.appendChild(el('p', 'dsn-text',
            'Deine Angaben sprechen für einen behutsamen Übergang: Wir strecken die Umstellung auf rund zwei Wochen, ' +
            'damit sich die Verdauung in Ruhe anpassen kann.'));
        }

        if (ration) {
          var secM = el('div', 'dsn-subcard');
          secM.appendChild(el('p', 'dsn-subcard-title', 'Tagesration als Startwert'));
          var rows = [
            ['Pro Tag', 'ca. ' + ration.gramsPerDay + '\u00A0g'],
            ['Auf zwei Mahlzeiten', 'je ca. ' + ration.gramsPerMeal + '\u00A0g'],
            ['Rechenweg', (ration.factor * 100).toFixed(1).replace('.', ',').replace(',0', '') + '\u00A0% von ' + String(s.kg).replace('.', ',') + '\u00A0kg']
          ];
          rows.forEach(function (r) {
            var row = el('div', 'dsn-kv');
            row.appendChild(el('span', '', r[0]));
            row.appendChild(el('b', '', r[1]));
            secM.appendChild(row);
          });
          box.appendChild(secM);
        } else {
          box.appendChild(el('p', 'dsn-text',
            'Beim Senior hängt die passende Menge stark von Aktivität, Muskulatur und Gesundheit ab. ' +
            'Starte mit der bisherigen Menge und sprich Anpassungen mit deiner Tierarztpraxis ab.'));
        }

        var secP = el('div', 'dsn-subcard');
        secP.appendChild(el('p', 'dsn-subcard-title', res.slow ? 'Dein 14-Tage-Übergang' : 'Dein 7-Tage-Übergang'));
        transitionPlan(res.slow).forEach(function (t) {
          var row = el('div', 'dsn-kv');
          var tageLabel = el('span', '', t.tage);
          tageLabel.style.whiteSpace = 'nowrap'; /* kurze Zahlenphrase nie mitten in der Zahl brechen */
          row.appendChild(tageLabel);
          row.appendChild(el('b', '', t.neu + '\u00A0% neues Futter'));
          secP.appendChild(row);
        });
        box.appendChild(secP);

        var secB = el('div', 'dsn-subcard');
        secB.appendChild(el('p', 'dsn-subcard-title', 'Worauf du in den ersten zwei Wochen achtest'));
        secB.appendChild(el('p', 'dsn-text',
          'Kotkonsistenz, Appetit, Energie und Haut. Bleibt alles stabil oder wird besser, passt der Kurs. ' +
          'Wird etwas schlechter, geh einen Übergangsschritt zurück und gib der Verdauung zwei, drei Tage.'));
        box.appendChild(secB);

        var bridgeWrap = el('div', 'dsn-subcard dsnc-bridge-wrap');
        bridgeWrap.appendChild(el('p', 'dsn-subcard-title', 'Der einfachste Start: BARF Kennenlern-Box'));
        var days = ration ? boxDays(self.boxGrams, ration.gramsPerDay) : null;
        bridgeWrap.appendChild(el('p', 'dsn-text',
          'Fünf Sorten mit Innereien, zusammen 2 kg, roh und schockgefrostet vom Metzgermeister. ' +
          'So findest du in Ruhe die Sorte, die deinem Hund liegt' +
          (days ? '. Bei deiner Tagesration reicht die Box etwa ' + days + ' Tage.' : '.')));
        var link = el('a', 'dsn-cta', 'BARF Kennenlern-Box ansehen');
        link.href = self.boxUrl + (self.boxUrl.indexOf('?') === -1 ? '?' : '&') + 'utm_source=ai-bridge';
        link.setAttribute('data-event', 'ai_bridge_click_futterwechsel_check_kennenlern-box');
        var arrow = el('span', '');
        arrow.innerHTML = ARROW_SVG;
        arrow.setAttribute('aria-hidden', 'true');
        link.appendChild(arrow);
        bridgeWrap.appendChild(link);
        box.appendChild(bridgeWrap);

        box.appendChild(el('p', 'dsn-note',
          'Startwert für gesunde, erwachsene Hunde, keine tierärztliche Empfehlung. Beobachte deinen Hund und passe in kleinen Schritten an.'));
        box.appendChild(self.actionRow('Plan drucken'));
        root.appendChild(box);
      });
    }
  }

  customElements.define('ds-nav-check', DsNavCheck);
})();
